import { createContext } from 'react';
import { TenantContextProvider } from '../interfaces/tenant.interface';

export const TenantContext = createContext<TenantContextProvider>({
  tenantInfo: null,
  isValidating: false,
  validateDomain: async () => { },
});
